import { DocumentCreationItemContainer } from '@/features/documents/DocumentCreationModal/DocumentCreationItem/DocumentCreationItemContainer'
import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { JobProgressionUploadModal } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionUploadModal'
import { type JobProgressionFlow } from '@/features/jobs/taxes/progression/JobProgression'
import { match } from '@/utils/pattern-match-util'

export interface JobProgressionDocumentCreationModalContainerProps {
  vm: JobProgressionViewModel
}

export const JobProgressionDocumentCreationModalContainer = observer(
  function JobProgressionDocumentCreationModalContainer({
    vm,
  }: JobProgressionDocumentCreationModalContainerProps) {
    const documentCreationVm = vm.jobProgressionDocumentCreationVm!

    return (
      <JobProgressionUploadModal
        showing={documentCreationVm.modal.showing}
        dragging={documentCreationVm.dragging}
        title={getTitle(vm.currentProgressionFlow)}
        description={getDescription(vm.currentProgressionFlow)}
        isSkipDisabled={vm.isSkipUploadDisabled}
        isUploadDisabled={vm.isUploadDisabled || vm.answerReturnFiled.pending}
        isUploadPending={vm.answerReturnFiled.pending}
        onRequestClose={vm.closeDocumentCreationModal}
        onAddFiles={documentCreationVm.addFiles}
        onDragEnter={documentCreationVm.setDragging}
        onDragLeave={documentCreationVm.stopDragging}
        onSkip={() => vm.answerReturnFiled(true)}
        onUpload={() => vm.answerReturnFiled(false)}
        fileInputTestId="upload-final-documents-file-input"
        uploadButtonTestId="upload-final-documents-confirm-button"
      >
        {documentCreationVm.documentCreationItemVms.map(
          (docCreationItemVm, index) => (
            <div key={index}>
              <DocumentCreationItemContainer
                index={index}
                vm={docCreationItemVm}
                onRemove={documentCreationVm.removeFile}
              />
            </div>
          ),
        )}
      </JobProgressionUploadModal>
    )
  },
)

function getTitle(flow: JobProgressionFlow) {
  switch (flow) {
    case 'Preparation':
      return 'Upload preparation notes'
    case 'Review':
      return 'Upload review notes'
    default:
      return 'Upload final documents'
  }
}

function getDescription(flow: JobProgressionFlow) {
  return match(flow, {
    Retail: () => (
      <>
        Upload the final return and the e-file confirmation to finalize the job
      </>
    ),
    Outsourcing: () => <>Upload the final return and the e-file confirmation</>,
    Essential: () => (
      <>
        Upload the annotated source documents to complete the job.
        <br />
        Upload a missing items list if applicable.
      </>
    ),
    None: () => <>Upload the final return and the e-file confirmation</>,
    Preparation: () => <>Upload the final documents to complete the job.</>,
    Review: () => <>Upload the final documents to complete the job.</>,
    PersonalExtension: () => <></>,
    BusinessExtension: () => <></>,
    OutsourcingExtension: () => <></>,
  })
}
